 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"attendance-clock-record":"attendance-clock-record","attendance-clock-stats~shift-manage":"attendance-clock-stats~shift-manage","attendance-clock-stats":"attendance-clock-stats","shift-manage":"shift-manage","autidt-list":"autidt-list","carousel-list~link-list~menu-list~permissions-list":"carousel-list~link-list~menu-list~permissions-list","menu-list":"menu-list","permissions-list":"permissions-list","position-list":"position-list","individual-list":"individual-list","user-list":"user-list","bill-edit":"bill-edit","customer-view":"customer-view","individual-view":"individual-view","manage-members":"manage-members","ad-position-list":"ad-position-list","article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":"article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit","article-edit":"article-edit","company-edit":"company-edit","openapiServer-edit":"openapiServer-edit","settlement-edit":"settlement-edit","article-list":"article-list","attachment-list":"attachment-list","autidt-bill~autidt-contract~autidt-view~daily-settlement":"autidt-bill~autidt-contract~autidt-view~daily-settlement","autidt-view":"autidt-view","carousel-list":"carousel-list","link-list":"link-list","company-list":"company-list","lecturer-list":"lecturer-list","autidt-bill":"autidt-bill","autidt-contract":"autidt-contract","daily-settlement":"daily-settlement","article-create":"article-create","bill-list":"bill-list","common-list":"common-list","customer-list":"customer-list","roles-list":"roles-list","task-list":"task-list","openapiServer-list":"openapiServer-list","settlement-list":"settlement-list","sys_log-list~withdraw-list":"sys_log-list~withdraw-list","sys_log-list":"sys_log-list","withdraw-list":"withdraw-list","tax-list":"tax-list","ws_account":"ws_account","category-list":"category-list","live-list":"live-list","setting-site":"setting-site","everyday_statistics":"everyday_statistics","exception-404":"exception-404","login":"login","new_hr":"new_hr","register":"register","setting-base":"setting-base","statistics-flow~statistics-region":"statistics-flow~statistics-region","statistics-flow":"statistics-flow","statistics-region":"statistics-region","statistics-list":"statistics-list","token-login":"token-login"}[chunkId]||chunkId) + "." + {"attendance-clock-record":"36f345be","attendance-clock-stats~shift-manage":"416207e2","attendance-clock-stats":"0b93e35e","shift-manage":"4ca186d7","autidt-list":"10394940","carousel-list~link-list~menu-list~permissions-list":"5cc025de","menu-list":"77a8d726","permissions-list":"edadce28","chunk-05dd824a":"d8bbde8e","chunk-2e0f34bd":"4a142cc3","chunk-689139d2":"7fb824aa","chunk-73be8d41":"aa7b6af2","position-list":"cd1354c9","chunk-7bc477e4":"6eb0b10b","individual-list":"1b46de22","user-list":"52e29d51","chunk-3108329c":"267bb9e9","chunk-325098ac":"4f250e7d","chunk-59f10238":"01388da8","chunk-6e83591c":"163e5349","chunk-34182fda":"ea39283e","chunk-c442ea18":"9e0b23b3","bill-edit":"a23fa516","chunk-392798fa":"ea5c585d","chunk-119d2fd9":"5ba0c107","customer-view":"7d0e620c","individual-view":"1e60b5c1","manage-members":"0e0f360c","chunk-5ccfe9ff":"88ecde4a","chunk-1c8840f0":"db233826","chunk-2d80da10":"cadf15d4","chunk-2b3e2cfe":"b1e76244","chunk-78c4cfe8":"a7ca2b6e","chunk-26dada40":"a22349f2","chunk-37930f86":"51e9b705","chunk-9e9c9b90":"5c5cdf13","ad-position-list":"bf7448eb","article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":"10354d72","article-edit":"3bd4f705","company-edit":"cc5eb638","openapiServer-edit":"2c4e2446","settlement-edit":"d55214cf","article-list":"2b21e856","attachment-list":"a9f4b6bf","autidt-bill~autidt-contract~autidt-view~daily-settlement":"c2333891","autidt-view":"3d7a054a","carousel-list":"873d8f22","link-list":"af1f7291","company-list":"6307d36c","lecturer-list":"394d249b","autidt-bill":"acaac3f9","autidt-contract":"65b54c22","daily-settlement":"5e0c5412","chunk-4e000596":"7b285107","article-create":"80e172c5","bill-list":"52261e53","common-list":"3545127f","customer-list":"785a32aa","roles-list":"6a5b88a8","task-list":"e74b552a","openapiServer-list":"838586db","settlement-list":"ee7a795d","sys_log-list~withdraw-list":"7f462e76","sys_log-list":"8739de61","withdraw-list":"f9139943","tax-list":"49cda7ce","ws_account":"e1ee90ba","category-list":"61ae3d9b","live-list":"ee5ba2d4","setting-site":"31c8ac16","chunk-ccbb65ca":"c007b4e4","chunk-fdf9545a":"b10fef28","everyday_statistics":"b3c81d75","exception-404":"4b7eeaed","login":"4100ac63","new_hr":"b6cfc429","register":"0be20650","setting-base":"bdc7ee7f","statistics-flow~statistics-region":"c6494b83","statistics-flow":"8c4d618c","statistics-region":"cc9d08de","statistics-list":"4af4ce1c","token-login":"a58294df","chunk-a15b667e":"1e595c6e","chunk-2d225891":"394a0912"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"attendance-clock-record":1,"attendance-clock-stats~shift-manage":1,"attendance-clock-stats":1,"shift-manage":1,"autidt-list":1,"carousel-list~link-list~menu-list~permissions-list":1,"menu-list":1,"permissions-list":1,"chunk-05dd824a":1,"chunk-2e0f34bd":1,"chunk-689139d2":1,"position-list":1,"chunk-7bc477e4":1,"individual-list":1,"user-list":1,"chunk-3108329c":1,"chunk-325098ac":1,"chunk-59f10238":1,"chunk-c442ea18":1,"bill-edit":1,"chunk-392798fa":1,"chunk-119d2fd9":1,"customer-view":1,"individual-view":1,"manage-members":1,"chunk-5ccfe9ff":1,"chunk-1c8840f0":1,"chunk-2d80da10":1,"chunk-2b3e2cfe":1,"chunk-78c4cfe8":1,"chunk-26dada40":1,"chunk-37930f86":1,"ad-position-list":1,"article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":1,"article-edit":1,"company-edit":1,"openapiServer-edit":1,"settlement-edit":1,"article-list":1,"attachment-list":1,"autidt-bill~autidt-contract~autidt-view~daily-settlement":1,"autidt-view":1,"carousel-list":1,"link-list":1,"company-list":1,"lecturer-list":1,"autidt-bill":1,"autidt-contract":1,"daily-settlement":1,"chunk-4e000596":1,"article-create":1,"bill-list":1,"common-list":1,"customer-list":1,"roles-list":1,"task-list":1,"openapiServer-list":1,"settlement-list":1,"sys_log-list~withdraw-list":1,"sys_log-list":1,"withdraw-list":1,"tax-list":1,"ws_account":1,"category-list":1,"live-list":1,"setting-site":1,"chunk-ccbb65ca":1,"chunk-fdf9545a":1,"everyday_statistics":1,"exception-404":1,"login":1,"new_hr":1,"register":1,"setting-base":1,"statistics-flow":1,"statistics-region":1,"statistics-list":1,"token-login":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"attendance-clock-record":"attendance-clock-record","attendance-clock-stats~shift-manage":"attendance-clock-stats~shift-manage","attendance-clock-stats":"attendance-clock-stats","shift-manage":"shift-manage","autidt-list":"autidt-list","carousel-list~link-list~menu-list~permissions-list":"carousel-list~link-list~menu-list~permissions-list","menu-list":"menu-list","permissions-list":"permissions-list","position-list":"position-list","individual-list":"individual-list","user-list":"user-list","bill-edit":"bill-edit","customer-view":"customer-view","individual-view":"individual-view","manage-members":"manage-members","ad-position-list":"ad-position-list","article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":"article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit","article-edit":"article-edit","company-edit":"company-edit","openapiServer-edit":"openapiServer-edit","settlement-edit":"settlement-edit","article-list":"article-list","attachment-list":"attachment-list","autidt-bill~autidt-contract~autidt-view~daily-settlement":"autidt-bill~autidt-contract~autidt-view~daily-settlement","autidt-view":"autidt-view","carousel-list":"carousel-list","link-list":"link-list","company-list":"company-list","lecturer-list":"lecturer-list","autidt-bill":"autidt-bill","autidt-contract":"autidt-contract","daily-settlement":"daily-settlement","article-create":"article-create","bill-list":"bill-list","common-list":"common-list","customer-list":"customer-list","roles-list":"roles-list","task-list":"task-list","openapiServer-list":"openapiServer-list","settlement-list":"settlement-list","sys_log-list~withdraw-list":"sys_log-list~withdraw-list","sys_log-list":"sys_log-list","withdraw-list":"withdraw-list","tax-list":"tax-list","ws_account":"ws_account","category-list":"category-list","live-list":"live-list","setting-site":"setting-site","everyday_statistics":"everyday_statistics","exception-404":"exception-404","login":"login","new_hr":"new_hr","register":"register","setting-base":"setting-base","statistics-flow~statistics-region":"statistics-flow~statistics-region","statistics-flow":"statistics-flow","statistics-region":"statistics-region","statistics-list":"statistics-list","token-login":"token-login"}[chunkId]||chunkId) + "." + {"attendance-clock-record":"8924ce90","attendance-clock-stats~shift-manage":"6fdfe8be","attendance-clock-stats":"b1e375a0","shift-manage":"baffa913","autidt-list":"f1cf9de3","carousel-list~link-list~menu-list~permissions-list":"f1cf9de3","menu-list":"8bc0eb7c","permissions-list":"b9c9ddca","chunk-05dd824a":"41f49f96","chunk-2e0f34bd":"151fb899","chunk-689139d2":"8aa71e8a","chunk-73be8d41":"31d6cfe0","position-list":"8c8b504f","chunk-7bc477e4":"f6005c5c","individual-list":"ca7875e5","user-list":"0fbd0d20","chunk-3108329c":"f487520e","chunk-325098ac":"f47a419e","chunk-59f10238":"a1e9056b","chunk-6e83591c":"31d6cfe0","chunk-34182fda":"31d6cfe0","chunk-c442ea18":"db5c6c4e","bill-edit":"127772d2","chunk-392798fa":"92464486","chunk-119d2fd9":"59d188eb","customer-view":"c5a55abb","individual-view":"6f914dec","manage-members":"14704666","chunk-5ccfe9ff":"dbbaae3d","chunk-1c8840f0":"44798df4","chunk-2d80da10":"07e65ce0","chunk-2b3e2cfe":"2a50113c","chunk-78c4cfe8":"0f8b4c06","chunk-26dada40":"2b873ffa","chunk-37930f86":"60921343","chunk-9e9c9b90":"31d6cfe0","ad-position-list":"6c15f24d","article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":"fcca00d1","article-edit":"81c2326f","company-edit":"6a772072","openapiServer-edit":"372bfbde","settlement-edit":"9f445d30","article-list":"fc157c4b","attachment-list":"14bd5e7b","autidt-bill~autidt-contract~autidt-view~daily-settlement":"befd2898","autidt-view":"a7887fef","carousel-list":"5332e5a6","link-list":"bf53ea62","company-list":"f64fc625","lecturer-list":"886cab67","autidt-bill":"5f186058","autidt-contract":"f15e237e","daily-settlement":"9419698f","chunk-4e000596":"f3579bd2","article-create":"7c0c27a6","bill-list":"bacca06c","common-list":"18a54ca1","customer-list":"84fe8479","roles-list":"e30af8ba","task-list":"9e4bb863","openapiServer-list":"ff12898c","settlement-list":"a1529f2c","sys_log-list~withdraw-list":"2513fa6f","sys_log-list":"a823e037","withdraw-list":"c2e02f20","tax-list":"ad4ccbf6","ws_account":"98eb842a","category-list":"65c3310f","live-list":"a512e19f","setting-site":"edb73df0","chunk-ccbb65ca":"df2f2f8d","chunk-fdf9545a":"614c7561","everyday_statistics":"508ea32f","exception-404":"604eae9b","login":"57d1f132","new_hr":"3434eff9","register":"a516e40b","setting-base":"f1cf9de3","statistics-flow~statistics-region":"31d6cfe0","statistics-flow":"40a66952","statistics-region":"112f20a9","statistics-list":"f1cf9de3","token-login":"4efaaed6","chunk-a15b667e":"31d6cfe0","chunk-2d225891":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
